// store/features/api/doctorEarningApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

const normalizeDoctorFinanceParams = (params = {}) => {
  const { startDate, endDate, ...rest } = params;
  return {
    ...rest,
    ...(startDate ? { start_date: startDate } : {}),
    ...(endDate ? { end_date: endDate } : {}),
  };
};

export const doctorEarningApi = createApi({
  reducerPath: "doctorEarningApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}doctor-earning/`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token || localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["doctor_earning"],
  endpoints: (builder) => ({
    getDoctorEarnings: builder.query({
      query: (params) => ({
        url: "",
        params: normalizeDoctorFinanceParams(params),
      }),
      providesTags: ["doctor_earning"],
    }),
    getDoctorEarning: builder.query({
      query: (id) => `${id}`,
      providesTags: ["doctor_earning"],
    }),
    getEarningSummary: builder.query({
      query: (params) => ({
        url: "summary",
        params: normalizeDoctorFinanceParams(params),
      }),
      providesTags: ["doctor_earning"],
    }),
    addDoctorEarning: builder.mutation({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["doctor_earning"],
    }),
    updateDoctorEarning: builder.mutation({
      query: ({ id, data }) => ({
        url: `${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["doctor_earning"],
    }),
    deleteDoctorEarning: builder.mutation({
      query: (id) => ({
        url: `${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["doctor_earning"],
    }),
    approveEarning: builder.mutation({
      query: (id) => ({
        url: `${id}/approve`,
        method: "PATCH",
      }),
      invalidatesTags: ["doctor_earning"],
    }),
    batchApproveEarnings: builder.mutation({
      query: (earningIds) => ({
        url: "batch-approve",
        method: "PATCH",
        body: { earning_ids: earningIds },
      }),
      invalidatesTags: ["doctor_earning"],
    }),
  }),
});

export const {
  useGetDoctorEarningsQuery,
  useGetDoctorEarningQuery,
  useGetEarningSummaryQuery,
  useAddDoctorEarningMutation,
  useUpdateDoctorEarningMutation,
  useDeleteDoctorEarningMutation,
  useApproveEarningMutation,
  useBatchApproveEarningsMutation,
} = doctorEarningApi;
